const NavMobile = (function(window, $) {

    function NavMobile() {

        this.menuIcon = $('.menu-icon-container');
        this.closeIcon = $('.close-icon-container');
        this.body = $('body');
        this.overlay = $('.overlay-default');
        this.navMobileParent = $('.menu-item-has-children');
        this.navMobileParentItem = $('.menu-item-has-children .nav-link-primary');
        this.navMobileSubParentItem = $('.menu-item-has-subchildren .nav-link-secondary');

        this.addEvents();
    }

    NavMobile.prototype.addEvents = function() {
        this.menuIcon.on('click', this.handleClickMenuIcon.bind(this));
        this.closeIcon.on('click', this.handleClickCloseIcon.bind(this));
        this.overlay.on('click', this.handleClickOverlay.bind(this));
        this.navMobileParentItem.on('click', this.handleClickNavMobileParentItem.bind(this));
        this.navMobileSubParentItem.on('click', this.handleClickNavMobileSubParentItem.bind(this));
    };


    NavMobile.prototype.handleClickMenuIcon = function() {
        this.overlay.fadeIn('slow');
        this.body.addClass('mobile-nav-active');
    }

    NavMobile.prototype.handleClickCloseIcon = function() {
        this.overlay.fadeOut('slow');
        this.body.removeClass('mobile-nav-active');
    }

    NavMobile.prototype.handleClickOverlay = function() {
        this.overlay.fadeOut('slow');
        this.body.removeClass('mobile-nav-active');
    }

    NavMobile.prototype.handleClickNavMobileParentItem = function(e) {
        e.preventDefault();
        $(e.target).toggleClass('child-list-open');
        this.navMobileParentItem.not(e.target).removeClass('child-list-open');
        this.navMobileParent.toggleClass('menu-open');
    }

    NavMobile.prototype.handleClickNavMobileSubParentItem = function(e) {
        e.preventDefault();
        $(e.target).toggleClass('child-list-open');
        this.navMobileSubParentItem.not(e.target).removeClass('child-list-open');
    }
    
    return NavMobile;

}(window, jQuery));

export {NavMobile};